import { render, staticRenderFns } from "./AddYearDialog.vue?vue&type=template&id=d2db7dc4&scoped=true&"
import script from "@/views/Years/AddYearDialog.ts?vue&type=script&lang=ts&"
export * from "@/views/Years/AddYearDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Years/add-year-dialog.scss?vue&type=style&index=0&id=d2db7dc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2db7dc4",
  null
  
)

export default component.exports